import { showLoader, hideLoader } from '../../../Shared/Loader';
import { Ajax } from '../../../components/Ajax';
import { ApiUrl } from '../../../project/Defines';
import { message } from 'antd';
import { dispatchCustomEvent } from '../../../project/utilities';
import FileSaver from 'file-saver';

const loaderName = 'FAQ_FILE_UPLOAD_LOADER';
const exportLoaderName = 'FAQ_FILE_EXPORT_LOADER';

export function FaqImport(data, listUpdateEvent, successCallback, url) {
    showLoader(loaderName);
    Ajax.post({
        url: url || ApiUrl.FaqImport,
        data: {
            file: data && data.file
        },
        success: (response) => {
            if (!response.HasError) {
                successCallback && successCallback(response);
                dispatchCustomEvent(listUpdateEvent);
                hideLoader(loaderName);
            } else {
                message.error(response.message);
                hideLoader(loaderName);
            }
        }
    });
}

export function FaqExport(url) {
    showLoader(exportLoaderName);
    Ajax.download({
        url: url || ApiUrl.FaqExport,
        data: {},
        //autoDownload: false,
        success: (blob) => {
            const fileName = url ? "Thercodim_Faq.xlsx" : "Aquamde_Faq.xlsx";

            FileSaver.saveAs(blob,  fileName);
            hideLoader(exportLoaderName);
        },
        error: () => {
            hideLoader(exportLoaderName);
        }
    });
}